import { FC, useState } from 'react';

import DealTabsForInvites from './DealTabsForInvites';
import InviteLinks from './InviteLinks';
import InviteNetwork from './InviteNetwork';
import ManageInvites from './ManageInvites';

const InviteUsersToDeal: FC = () => {
  const [activeTab, setActiveTab] = useState('manage-invites');

  function renderContent() {
    switch (activeTab) {
      case 'manage-invites':
        return <ManageInvites />;
      case 'invite-network':
        return <InviteNetwork />;
      case 'invite-links':
        return <InviteLinks />;
      default:
        return null;
    }
  }

  return (
    <div className="w-full grid grid-cols-6 gap-x-8">
      <div className="col-span-2 relative">
        <DealTabsForInvites activeTab={activeTab} onSelect={setActiveTab} />
      </div>
      <div className="col-span-4">{renderContent()}</div>
    </div>
  );
};

export default InviteUsersToDeal;
